import {useEffect} from 'react';

import {SIDEBAR_MORE_ICON_SIZE} from '../../../const';
import {calculateNumberOfSidebarItemsDisplayable} from '../../../utils';
import useMainSidebar from '../../providers/useMainSidebar';
import useReport from '../../providers/useReport';

const useSidebarReports = (containerHeight, canDisplayAllReports) => {
  const {setSidebarReports} = useMainSidebar();
  const {reports} = useReport();

  useEffect(() => {
    const containerHeightWithoutMoreIcon = canDisplayAllReports ? containerHeight : containerHeight - SIDEBAR_MORE_ICON_SIZE;
    const numberOfReportsDisplayable = calculateNumberOfSidebarItemsDisplayable(containerHeightWithoutMoreIcon);
    const reportsWithVisibleProp = reports.map((r, index) => ({
      ...r,
      is_visible: index < numberOfReportsDisplayable
    }));

    setSidebarReports(reportsWithVisibleProp);
  }, [reports, containerHeight, canDisplayAllReports, setSidebarReports]);
};

export default useSidebarReports;
